import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthorisationService } from '@services/authorisation.service'
import { filter, Subscription, take } from 'rxjs'
import { IamStore } from 'src/app/modules/proficloud/stores/iam.store'

@Component({
  selector: 'ums-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent implements OnInit, OnDestroy {
  private auth = inject(AuthorisationService)
  private router = inject(Router)
  private iamStore = inject(IamStore)

  private organisationLoadedSubscription: Subscription

  constructor() {}

  ngOnInit(): void {
    this.iamStore.storeInitialised$
      .pipe(
        filter((erorred) => erorred !== undefined),
        take(1)
      )
      .subscribe(() => {
        this.redirectNonAdmins()
      })
  }

  ngOnDestroy(): void {
    this.organisationLoadedSubscription?.unsubscribe()
  }

  private redirectNonAdmins() {
    if (!this.auth.isAdmin(this.iamStore.currentOrganisation)) {
      this.router.navigate(['/services/device-management/list'])
    }
  }
}
